import {
	ORG_USERS
} from '../dataProvider/constant';

const DEFAULT_STATE = {
	users: [],
	totalUsers: 0
}

export default (state = DEFAULT_STATE, action) => {
	switch (action.type) {
		case ORG_USERS:
			return{...state, users: action.payload.orgUsers, totalUsers: action.payload.org_users_count};
		default:
			return state;
	}
}